var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeTerrorist01 = function SvgTypeTerrorist01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -22.18,
    y1: 125.2,
    x2: 138.95,
    y2: -21.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -9.72,
    y1: 138.88,
    x2: 151.41,
    y2: -7.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 41.75,
    y1: 195.36,
    x2: 202.88,
    y2: 48.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -14.6,
    y1: 133.52,
    x2: 146.53,
    y2: -13.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 34.59,
    y1: 187.51,
    x2: 195.72,
    y2: 40.68,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Terrorist"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.83,53.03h13.57c.68,0,1.02.68.68,1.02-2.03,3.39-8.82,11.87-14.92,0,0-.34.34-1.02.68-1.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.3,53.03h13.57c.68,0,1.02.68.68,1.02-2.03,3.39-8.82,11.87-14.92,0,0-.34.34-1.02.68-1.02h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.71,47.94c3.73-3.39,2.71-9.5-1.7-11.87l-14.58-7.8c-3.39-1.7-7.46-.68-9.5,2.37l-23.06,32.9-3.05-2.03c-.68-.34-1.36-.34-1.7.34l-8.14,12.89-2.03-1.36c-1.02-.68-2.37-.34-3.05,1.02l-16.28,28.15,11.19,3.39c7.8,2.37,14.24,7.8,17.97,14.92l4.41-7.8c7.46,1.36,14.58,5.09,19.67,10.51,1.02,1.02,3.05,1.02,3.73-.34l4.07-6.78c.68-1.02.34-2.03-.34-2.71-3.05-3.05-6.44-5.43-10.17-7.46-3.39-1.7-7.12-3.05-10.85-4.07l2.71-4.75,21.03-2.71c1.36,0,2.03-1.36,2.03-2.37l-.68-9.5c0-1.36-1.36-2.37-2.71-2.03l-11.53,1.36,2.03-4.07,30.52-30.18ZM180.42,38.45c3.05,0,5.43,2.37,5.43,5.43s-2.37,5.43-5.43,5.43-5.43-2.37-5.43-5.43,2.37-5.43,5.43-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.52,10.64c-24.42,0-44.09,19.67-44.09,44.09s19.67,51.21,44.09,51.21,44.09-26.79,44.09-51.21S93.94,10.64,69.52,10.64ZM101.06,57.1c-8.48,6.78-19.33,10.85-31.2,10.85s-22.72-4.07-31.2-10.85c-4.41-3.39-2.03-10.51,3.73-10.51h55.62c4.75.34,7.12,7.12,3.05,10.51Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.76,113.73l-23.4-7.12c-8.48,6.78-18.65,10.85-29.84,10.85s-21.37-4.07-29.84-10.85l-9.5,2.71v14.58h-15.26v-9.83C6.1,117.47,0,126.28,0,135.78v46.12C0,185.97,3.39,189.36,7.46,189.36h124.8c4.07,0,7.46-3.39,7.46-7.46v-45.78c-.34-10.17-7.12-19.33-16.96-22.38ZM30.18,153.75h-15.26v-9.16h15.26v9.16ZM30.18,159.52v9.16h-15.26v-9.16h15.26ZM30.18,129.67v9.16h-15.26v-9.16h15.26ZM14.92,183.93v-9.5h15.26v9.5h-15.26Z"
  }))));
};
export default SvgTypeTerrorist01;